import React, { Fragment } from 'react';
import { Segment, Header, Button, Table, Checkbox, Popup, Icon, Grid, Divider } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import Filters from './Filters';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class StudentsWithGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedData: [],
            filterData: [],
            results: [],

            showFiltersOnButton: false,
            showFilterMode: null,
            registered: false,
            // isThisButtonLoading: false,
            loadingButton: props.loadingButton,
        };

        this.onSelectRow = this.onSelectRow.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.addToGroup = this.addToGroup.bind(this);

        this.getDataToRender = this.getDataToRender.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    onSelectRow(studentCourseImplementationId) {
        const row = this.getDataToRender().find(el => el.studentCourseImplementationId === studentCourseImplementationId);
        const pos = this.state.selectedData.findIndex(el => el.studentCourseImplementationId === row.studentCourseImplementationId);
        if (pos === -1) {
            // add to selectedData
            this.setState({ selectedData: [...this.state.selectedData, row] });
        } else {
            // remove from selectedData
            const newSelectedData = this.state.selectedData.filter(el => el.studentCourseImplementationId !== row.studentCourseImplementationId);
            this.setState({ selectedData: newSelectedData });
        }
    }

    selectAll() {
        const { selectedData } = this.state;
        // deselect all if data.length === selectedData.length
        if (selectedData.length === this.getDataToRender().length) {
            this.setState({ selectedData: [] });
        } else {
            this.setState({ selectedData: this.getDataToRender() });
        }
    }

    addToGroup() {
        if (!this.state.selectedData.length) {
            toast('Niste odabrali nijednog studenta!');
            return;
        }
        let list = [];
        this.state.selectedData.map(el => {
            list.push(el.studentCourseImplementationId);
        });

        this.props.handleButtonLoadingChange("add");
        // this.setState({isThisButtonLoading : true})

        axios.post(`course/groups/add-students/${this.props.courseImplementationGroupId}`, [...list])
            .then(res => {
                toast('Dodavanje u grupu je uspješno izvršeno!');
                this.setState({ selectedData: [], /*isThisButtonLoading : false */});
                this.props.handleButtonLoadingChange(true);
                this.props.getStudents();
                this.filtersOff();

            })
            .catch(err => {
                if (err.response.data === 'Student is already added to this group!') {
                    toast('Neki od odabranih studenata su već dodani u ovu grupu!');
                } else if (err.response.data === 'Student is already added to one course implementation group!') {
                    toast('Neki od odabranih studenata su već dodani u neku od grupa na ovom predmetu!');
                } else {
                    toast('Došlo je do greške! Dodavanje u grupu nije uspješno izvršeno!');
                }
                // this.setState({isThisButtonLoading : false})
                this.props.handleButtonLoadingChange(true);
            });
    }

    getDataToRender() {


        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.showFiltersOnButton) {
            if (this.state.registered) { return this.state.filterData.filter(el => el.studentGradedActivityId !== null); }
            return this.state.filterData;
        }
        if (this.state.registered && !this.state.showFiltersOnButton) { return this.props.data.filter(el => el.studentGradedActivityId !== null); }
        return this.props.data;
    }

    getFilterData(studyProgramBasicId, studyProgramId, studyTypeList, firstName, lastName, indexNumber) {
        let docFilter = {};
        if (studyProgramBasicId) docFilter = { ...docFilter, studyProgramBasicId };
        if (studyProgramId) docFilter = { ...docFilter, studyProgramId };
        if (studyTypeList) docFilter = { ...docFilter, studyTypeList };
        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (indexNumber) docFilter = { ...docFilter, indexNumber };

        if (this.state.showFilterMode) {
            if (studyProgramBasicId || studyTypeList || firstName || lastName || indexNumber) {
                this.setState({ showFiltersOnButton: true, showFilterMode: false });
            } else {
                toast('Morate unijeti po čemu želite filtrirati podatke!');
            }
        }
        axios.post(`course/groups/students/${this.props.courseImplementationGroupId}/${localStorage.getItem('groupType')}/false`, { ...docFilter })
            .then(res => {
                const filterData = res.data;
                this.setState({ filterData });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.props.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    getResults(results) {
        this.setState({ results });
    }

    render() {
        const { data, courseImplementationGroupId } = this.props;
        const { selectedData } = this.state;

        return (
            <div>
                <Divider horizontal>
                    <Header as="h3">Studenti na predmetu<br />
                    </Header>
                </Divider>
                <Fragment style={{ backgroundColor: 'white' }}>
                    {/* <Segment clearing> */}
                    {/* <Header as="h3"> */}
                    {/* Studenti raspoređeni u grupu */}
                    {/* {examGroup ? 'Svi studenti na predmetu' : 'Neraspoređeni studenti'} */}

                    {!this.props.loadingButton && <Header style={IconHeader} floated="right" >
                        {this.state.showFiltersOnButton && !this.props.loadingButton && <Button
                            onClick={this.filtersOff}
                            floated="left"
                            icon
                            labelPosition="right"
                            color="orange"
                            size="small"
                            style={FiltersOnStyle}
                        >
                            <Icon className="remove" onClick={this.filtersOff} />
                            Filtriranje uključeno!
                        </Button>}
                        <Icon />
                        <Popup
                            trigger={<Icon link circular basic="true" floated="right" name="filter" onClick={this.activateFilter} />}
                            content="Filtriranje podataka"
                            hideOnScroll
                            position="top center"
                        />
                    </Header>}


                    {this.state.showFilterMode && !this.props.loadingButton && <Filters
                        onFilterData={this.getFilterData}
                        filtersOff={this.filtersOff}
                    /> }

                    {/* <Segment clearing> */}
                    {/* {examGroup && <div> */}

                    {/* <Checkbox */}
                    {/* label="Prikaži samo studente koji su prijavili ispit" */}
                    {/* type="checkbox" */}
                    {/* name="registered" */}
                    {/* value={this.state.registered} */}
                    {/* onChange={() => { this.setState({ registered: !this.state.registered }); }} */}
                    {/* checked={this.state.registered} */}
                    {/* /> */}
                    {/* <br />  <br /> */}
                    {/* </div>} */}
                    {this.getDataToRender().length ?
                        <div><Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={this.props.edit ? 14 : 13}>
                                        <SearchTableData disabled={this.props.loadingButton}  profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['lastName', 'firstName', 'indexNumber']} />
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    {this.props.edit && <Table.HeaderCell width={1}>
                                        <Checkbox
                                            disabled={this.props.loadingButton}
                                            type="checkbox"
                                            name="checkAllButton"
                                            value={selectedData.length === this.getDataToRender().length}
                                            onChange={this.selectAll}
                                            checked={selectedData.length === this.getDataToRender().length}
                                        />
                                    </Table.HeaderCell>}
                                    <Table.HeaderCell colSpan={2}>
                                        R. br.
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={7}>
                                        Prezime i ime
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={4}>
                                        Broj indexa
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.getDataToRender().map((el, index) =>
                                (<Table.Row
                                    positive={el.courseImplementationGroupId === courseImplementationGroupId}
                                    negative={el.courseImplementationGroupId !== null && el.courseImplementationGroupId !== courseImplementationGroupId}
                                    onClick={() => this.onSelectRow(el.studentCourseImplementationId)}
                                >
                                    {this.props.edit && <Table.Cell verticalAlign="middle">
                                        <Checkbox
                                            disabled={this.props.loadingButton || (el.courseImplementationGroupId !== null && el.courseImplementationGroupId !== courseImplementationGroupId)}
                                            name={el.studentCourseImplementationId}
                                            type="checkbox"
                                            checked={selectedData.findIndex(e => e.studentCourseImplementationId === el.studentCourseImplementationId) > -1 && !(el.courseImplementationGroupId !== null && el.courseImplementationGroupId !== courseImplementationGroupId)}
                                        />

                                    </Table.Cell>}
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={7}>
                                        {el.lastName}       {el.firstName}    {el.droppedOutDate !== null ? (
                                        <span style={{ float: 'right', display: 'inline-flex', alignItems: 'center', gap: '6px', marginLeft: '8px' }}>
                                                <Popup
                                                    content="Ispisan student"
                                                    trigger={<Icon name="sign-out" color="red" />}
                                                    on="hover"
                                                    hideOnScroll
                                                    position="top center"
                                                />
                                            </span>
                                    ) : null}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={4}>
                                        {el.indexNumber}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                            {this.props.edit && <Button loading={this.props.loadingButton === "add"} disabled={this.props.loadingButton} color="blue" floated="right" onClick={this.addToGroup}>
                            Dodaj u grupu
                            </Button>}
                        </div>
                        : <div>{(this.props.examGroup && this.state.registered) ? 'Nema studenata koji su prijavili ispit.' : this.props.examGroup ? 'Nema studenata na ovom predmetu.' : 'Svi studenti su raspoređeni u grupe.'}</div>
                    }
                </Fragment>
                {/* <ToastContainer hideProgressBar /> */}
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StudentsWithoutGroup.js